"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _Search = _interopRequireDefault(require("../Search"));
var _OutputTable = _interopRequireDefault(require("../OutputTable"));
var _FormDialog = _interopRequireDefault(require("../FormDialog"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/RelationDialog/index.js";
var defaultProps = {};
function RelationDialog(_ref) {
  var schema = _ref.schema,
    onClickItem = _ref.onClickItem,
    onCancel = _ref.onCancel,
    findObject = _ref.findObject,
    saveObject = _ref.saveObject,
    saveImage = _ref.saveImage,
    saveFile = _ref.saveFile,
    schemas = _ref.schemas;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isAdd = _React$useState2[0],
    setIsAdd = _React$useState2[1];
  var _React$useState3 = _react["default"].useState({}),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    where = _React$useState4[0],
    setWhere = _React$useState4[1];
  function onSubmitSearch(where) {
    setWhere(where);
  }
  if (isAdd) {
    return /*#__PURE__*/_react["default"].createElement(_FormDialog["default"], {
      onSave: onClickItem,
      schema: schema,
      onBack: function onBack() {
        return setIsAdd(false);
      },
      findObject: findObject,
      saveObject: saveObject,
      saveFile: saveFile,
      saveImage: saveImage,
      schemas: schemas,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 13
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4 px-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "fw-bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 13
    }
  }, "Select ", schema.label || schema.collection), /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    className: "mt-3",
    fields: schema.fields,
    onSubmit: onSubmitSearch,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-auto mt-3",
    style: {
      maxHeight: "400px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement(_OutputTable["default"], {
    where: where,
    onClickItem: onClickItem,
    schema: schema,
    findObject: findObject,
    excludeFields: Object.keys(schema.fields).reduce(function (acc, key) {
      var options = schema.fields[key];
      if (options.read === false) {
        acc.push(key);
      }
      switch (options._type || options.type) {
        case 'Relation':
        case 'Array':
        case 'Object':
        case 'File':
          acc.push(key);
          break;
        default:
      }
      return acc;
    }, ['acl', 'password']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 17
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-end mt-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-sm",
    onClick: function onClick() {
      return setIsAdd(true);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-plus me-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 21
    }
  }), "ADD"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-outline-primary btn-sm ms-2",
    onClick: onCancel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 17
    }
  }, "CANCEL")));
}
RelationDialog.defaultProps = defaultProps;
var _default = RelationDialog;
exports["default"] = _default;